import React from 'react';
import { useTranslation } from 'react-i18next';
import './WelcomeScreen.css';

function WelcomeScreen({ isLoggedIn }) {
    const { t } = useTranslation();

    return (
        <div className="welcome-screen">
            <div className="welcome-content fade-scale-in">
                <h1>{t('welcome')}</h1>
                <p>{isLoggedIn ? t('welcomeTextAuth') : t('welcomeText')}</p>
            </div>
        </div>
    );
}

export default WelcomeScreen;
